const allLinks = document.querySelectorAll('div[data-redirect]');
const arr = Array.from(allLinks);
arr.forEach(link => {
  link.addEventListener('click', () => {
    const url = link.getAttribute('data-redirect');
    window.location.href = url;
  });
});
